import template from './categories.html';
import controller from './categories.controller';

const menuCategoriesComponent = {
  restrict: 'E',
  template,
  controller
};

export default menuCategoriesComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/categories/categories.component.js
 **/